// src/screens/CategoryScreen.js - Version Finale Propre
import { useParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetProductsByCategoryQuery } from '../slices/productsApiSlice';
import ProductOnLine from '../components/ProductOnLine';
import ProductPresential from '../components/ProductPresential';
import ProductOther from '../components/OtherProduct';

const CategoryScreen = ({ type = null }) => {
  const { categoryName } = useParams();

  // Mapping des catégories
  const categoryMapping = {
    'info': 'Informatique',
    'devp': 'Développement Personnel'
  };

  const actualCategory = categoryMapping[categoryName];
  
  const { 
    data: products, 
    isLoading, 
    error 
  } = useGetProductsByCategoryQuery({
    category: actualCategory,
    type: type
  }, {
    skip: !actualCategory
  });

  // Fonction pour choisir le bon composant Product selon le type
  const getProductComponent = (product) => {
    switch (product.type) {
      case 0: return <ProductPresential product={product} />;
      case 1: return <ProductOnLine product={product} />;
      case 2: return <ProductOther product={product} />;
      default: return <ProductPresential product={product} />;
    }
  };

  // Texte pour le type affiché dans le titre
  const getTypeText = () => {
    if (type === null) return '';
    switch (type) {
      case 0: return ' (Formations Présentielles)';
      case 1: return ' (Formations en Ligne)';
      case 2: return ' (Autres Produits)';
      default: return '';
    }
  };

  const displayCategoryName = categoryMapping[categoryName];

  // Si la catégorie n'existe pas dans le mapping
  if (!displayCategoryName) {
    return (
      <Message variant='danger'>Catégorie introuvable</Message>
    );
  }

  return (
    <div className="category-screen-container">
      <div className='page-heading'>
        <h1>
          {displayCategoryName}
        </h1>
        <p>{getTypeText().replace(/[()]/g, '') || 'Parcourir cette catégorie'}</p>
      </div>

      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>
          {error?.data?.message || error.error}
        </Message>
      ) : (
        <>
          <Row>
            {(!products || products.length === 0) ? (
              <Col>
                <Message variant='info' className="text-center py-5">
                  <h4>Aucun produit trouvé</h4>
                  <p className="mb-0">
                    Il n'y a pas encore de produits dans la catégorie "{displayCategoryName}" pour le moment.
                  </p>
                </Message>
              </Col>
            ) : (
              products.map((product) => (
                <Col key={product._id} sm={12} md={6} lg={4} xl={3} className="product-col mb-4">
                  {getProductComponent(product)}
                </Col>
              ))
            )}
          </Row>
        </>
      )}
    </div>
  );
};

export default CategoryScreen;